'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sun-bright';
var width = 576;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M168 256a120 120 0 1 0 240 0 120 120 0 1 0 -240 0z', 'M296 544l-16 0 0-96 16 0 0 96zM157.9 397.4l-67.9 67.9-11.3-11.3 67.9-67.9 11.3 11.3zM497.3 454l-11.3 11.3-67.9-67.9 11.3-11.3 67.9 67.9zM288 392a136 136 0 1 1 0-272 136 136 0 1 1 0 272zm0-256a120 120 0 1 0 0 240 120 120 0 1 0 0-240zM96 264l-96 0 0-16 96 0 0 16zm480 0l-96 0 0-16 96 0 0 16zM157.9 114.6L146.6 125.9 78.7 58 90 46.7 157.9 114.6zM497.3 58l-67.9 67.9-11.3-11.3 67.9-67.9 11.3 11.3zM296 64l-16 0 0-96 16 0 0 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;